import { Component, Input, OnInit } from '@angular/core';
import { ReservationService } from '../../services/reservation.service';
import Swal from 'sweetalert2';
import { TranslateService } from '@ngx-translate/core';
import { Utilities } from "../../utils/utilities";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { ImageModalComponent } from "../image-modal/image-modal.component";


@Component({
  selector: 'app-reservation-card',
  templateUrl: './reservation-card.component.html',
  styleUrls: ['./reservation-card.component.scss']
})
export class ReservationCardComponent implements OnInit {

  @Input() reservation: any;
  @Input() enabledEdit: boolean;
  foodSelectionNotComplete: boolean = false;

  constructor(private reservationService: ReservationService,
              private modalService: BsModalService,
              private translate: TranslateService) {
  }

  ngOnInit(): void {
    if (this.reservation.guests.length > 0) {
      this.reservation.guests.forEach(guest => {
        if (guest.preorderedDiys.length < 1) {
          this.foodSelectionNotComplete = true;
        }
      });
    } else {
      this.foodSelectionNotComplete = true;
    }
  }

  async success() {
    await this.reservationService.success(this.reservation.id).toPromise();
  }

  async notArrived() {
    Swal.fire({
      title: this.translate.instant('general.areUSure'),
      text: this.translate.instant('general.cantRevoke'),
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: this.translate.instant('general.yes'),
      cancelButtonText: this.translate.instant('general.cancel')
    }).then(async (result) => {
      if (result.value) {
        await this.reservationService.notArrived(this.reservation.id).toPromise();
      }
    });
  }

  diyToInProgress(ids: number[]) {
    this.reservationService.diyToInProgress(ids);
  }

  diyToSentOut(ids: number[]) {
    this.reservationService.diyToSentOut(ids);
  }

  setArchived() {
    this.reservationService.reservationArchiveStatusChange(this.reservation.id);
    this.reservation.archived = !this.reservation.archived;
  }

  setEdit() {
    this.reservationService.reservationIsEditStatusChange(this.reservation.id);
    this.reservation.isEdit = !this.reservation.isEdit;
  }

  showTray(traySrc: string, diyName: string) {
    const config = Utilities.createModalConfig({
      imgSrc: traySrc,
      diy: diyName
    });

    const modalRef: BsModalRef = this.modalService.show(ImageModalComponent, config);
    modalRef.content.onClose.subscribe(result => {
      console.log("modal yo")
    });
  }

}
